import { useEffect } from "react";
import { KycQuestionnaireListWidget } from "../../widgets/kycQuestionnaire";

export const KycQuestionnairePage = () => {
  useEffect(() => {
    document.title = "KYC Судалгаа";
  }, []);
  return (
    <div className="page">
      <KycQuestionnaireListWidget />
    </div>
  );
};
